<template>
  <div
    class="approval"
    :style="`padding-bottom: ${isBatchOperation ? '100px' : 0}`"
  >
    <Tabs :value="active" @on-click="onTabChange">
      <TabPane
        :label="$t(`approval.tab.${v}`)"
        :name="v"
        v-for="v in tabs[$route.query.type]"
        :key="v"
        :disabled="v === 'had_approved' && isBatchOperation"
      ></TabPane>
      <template slot="extra">
        <a
          href="javascript: void(0);"
          style="display: block; margin-top: 16px"
          :disabled="isBatchOperation || data.length === 0"
          @click="onBatchOperation"
          v-show="tab === 'approval_forms'"
        >
          {{ $t('global.batchOperation') }}
        </a>
        <Button
          class="read-btn"
          type="text"
          :loading="readBtnLoading"
          :disabled="data.length === 0"
          @click="onAllMarkedAsRead"
          v-show="tab === 'copied_forms' && active === 'notread'"
        >
          {{ $t('approval.allMarkedAsRead') }}
        </Button>
      </template>
    </Tabs>
    <div class="row-container vs-con-loading__container" id="div-with-loading3">
      <Row class="filter-box" type="flex" align="middle" :gutter="10">
        <Col>
          <span>{{ $t('approval.approvalType') }}：</span>
          <Select
            transfer
            class="text-left"
            clearable
            filterable
            v-model="filters.approvalId"
            @on-change="onApprovalChange"
            @on-clear="onApprovalClear"
          >
            <Option
              style="width: 200px"
              :value="v.id"
              v-for="(v, i) in categories"
              :key="v.id"
            >
              {{ v.title }}
            </Option>
          </Select>
        </Col>
        <Col>
          <span>{{ $t('approval.approvalCode') }}：</span>
          <InputNumber
            v-model="filters.idIndex"
            :min="0"
            clearable
            :placeholder="$t('i.textPlaceholder')"
          />
        </Col>
        <Col v-if="$route.query.type !== 'forms'">
          <span>{{ $t('approval.applicant') }}：</span>
          <Input
            v-model="filters.starter"
            clearable
            :placeholder="$t('i.textPlaceholder')"
          />
        </Col>
        <Col>
          <span>{{ $t('approval.startingTime') }}：</span>
          <DatePicker
            type="datetimerange"
            :placeholder="$t('i.select.placeholder')"
            format="yyyy-MM-dd"
            :editable="false"
            :value="[filters.createdAtStart, filters.createdAtEnd]"
            @on-change="onDateChange"
          ></DatePicker>
        </Col>
        <Col>
          <Button type="primary" @click="onSearch">
            {{ $t('global.inquire') }}
          </Button>
        </Col>
        <Col>
          <Button @click="onReset">{{ $t('i.table.resetFilter') }}</Button>
        </Col>
        <Col v-if="isAdvancedSearch">
          <Button
            type="text"
            style="color: #33b6b8"
            @click="onOpenSearchAdvanced"
          >
            {{ $t('global.advancedSearch') }}
          </Button>
        </Col>
      </Row>

      <Row
        justify="center"
        style="margin-top: 100px"
        v-if="!loading && data.length === 0"
      >
        <img
          style="width: 180px"
          src="@/assets/img/no-data.png"
          alt="no-data"
        />
        <p class="b-10">{{ $t('i.table.noDataText') }}</p>
      </Row>
      <template v-if="!loading && data.length > 0">
        <Table
          ref="oaTable"
          :columns="columns"
          :data="data"
          @on-row-click="sendMsg"
          @on-select="onTableSelect"
          @on-select-cancel="onTableSelectCancel"
          @on-select-all="onTableSelectAll"
          @on-select-all-cancel="onTableSelectAllCancel"
        />

        <Row justify="center" v-if="totalPages > 1" class="my-25">
          <Page
            :total="totalElements"
            :current="filters.page + 1"
            :page-size="filters.size"
            @on-change="changPage($event, 'page')"
          />
        </Row>
      </template>
    </div>

    <div class="operator-box" v-if="isBatchOperation">
      <Row class="operator" type="flex" align="middle" justify="space-between">
        <Row type="flex" :gutter="10">
          <Col>
            <p v-if="selectedData.length">
              <span v-if="selectAll || curPageSelectAll">
                {{ $t('approval.selectRecordAll') }}
              </span>
              <template v-else>
                <span>{{ selectedTexts[0] }}</span>
                <a
                  href="javascript: void(0);"
                  v-html="`${selectedData.length}${selectedTexts[1]}`"
                  @click="onViewSelected"
                ></a>
              </template>
            </p>
            <p v-else>{{ $t('approval.pleaseSelect') }}</p>
          </Col>
          <Col v-if="selectedData.length">
            <a href="javascript: void(0)" @click="onSelectAllCancel">
              {{ $t('approval.deselect') }}
            </a>
          </Col>
          <Col v-if="!selectAll && !curPageSelectAll">
            <a href="javascript: void(0)" @click="onSelectAll">
              {{ $t('approval.selectAll') }}
            </a>
          </Col>
        </Row>
        <Row type="flex" :gutter="10">
          <Col>
            <Button @click="onBatchTransferCancel">
              {{ $t('btn.cancel') }}
            </Button>
          </Col>
          <Col>
            <Button
              class="reject-btn"
              type="error"
              ghost
              :disabled="!selectedData.length"
              @click="onBatchConfirm('reject')"
            >
              {{ $t('btn.text2') }}
            </Button>
          </Col>
          <Col>
            <Button
              type="primary"
              ghost
              :disabled="!selectedData.length"
              @click="onBatchConfirm('transfer')"
            >
              {{ $t('approval.transfer') }}
            </Button>
          </Col>
          <Col>
            <Button
              type="primary"
              :disabled="!selectedData.length"
              @click="onBatchConfirm('approve')"
            >
              {{ $t('btn.text3') }}
            </Button>
          </Col>
        </Row>
      </Row>
    </div>

    <!-- 查看详情抽屉 -->
    <Drawer
      :title="$t('global.text7')"
      :width="505"
      :closable="true"
      :scrollable="false"
      :lock-scroll="true"
      v-model="drawerValue"
    >
      <iframe
        v-if="drawerValue"
        id="iframe"
        :src="h5_url"
        width="100%"
        style="height: 100%; width: 458px"
        title=""
      ></iframe>
    </Drawer>

    <ApprovalSearchAdvanced
      ref="approvalSearchAdvanced"
      @on-ok="onSearchAdvanced"
    />
    <!-- 圖片預覽 -->
    <Gallery :images="images" :index="index" @on-close="index = null" />
    <!-- 抄送 -->
    <CarbonCopyModal ref="carbonCopyModalRef" />
    <!-- 单个转交 -->
    <TransferModal ref="transferModalRef" @on-ok="getData" />
    <!-- 批量转交 -->
    <BatchTransferModal
      ref="batchTransferModalRef"
      :selectedCount="selectAll ? null : selectedData.length"
      :isSearchClick="isSearchClick"
      :filters="filters"
      :searchAdvancedParams="searchAdvancedParams"
      :value="transferForms"
      @on-ok="onBatchTransferOk"
    />
    <!-- 查看已选转交抽屉 -->
    <CheckTransferSelectedDrawer
      ref="checkTransferSelectedDrawerRef"
      @on-change="onCheckTransferSelectedChange"
    />
    <!-- 审批弹窗 -->
    <ApprovalModal
      ref="approvalModalRef"
      :selectAll="selectAll"
      :isSearchClick="isSearchClick"
      :filters="filters"
      :searchAdvancedParams="searchAdvancedParams"
      @on-ok="onApprovalOk"
    />
  </div>
</template>
<script>
import app_config from '@/commons/app_config';
import { AuthManage } from '@/plugins/auth';
import ApprovalSearchAdvanced from '@/components/approval-search-advanced/ApprovalSearchAdvanced.vue';
import Gallery from '@/components/gallery.vue';
import BatchTransferModal from './components/BatchTransferModal.vue';
import CheckTransferSelectedDrawer from './components/CheckTransferSelectedDrawer.vue';
import TransferModal from './components/TransferModal.vue';
import ApprovalModal from './components/ApprovalModal.vue';
import CarbonCopyModal from './components/CarbonCopyModal.vue';

export default {
  components: {
    ApprovalSearchAdvanced,
    Gallery,
    BatchTransferModal,
    CheckTransferSelectedDrawer,
    TransferModal,
    CarbonCopyModal,
    ApprovalModal
  },
  data() {
    this.initFilter = {
      page: 0,
      size: 6,
      readFlag: false,
      status: null,
      approvalId: null,
      createdAtStart: null,
      createdAtEnd: null,
      starter: null,
      idIndex: null
    };
    return {
      id: null,
      active: null,
      tab: null,
      drawerValue: false,
      totalElements: 0,
      totalPages: 0,
      loading: false,
      filters: _.cloneDeep(this.initFilter),
      categories: [],
      isAdvancedSearch: false,
      filter_from: {
        approval_forms: 'PENDING',
        had_approved: 'APPROVED',
        All: 'MY_ALL',
        PENDING: 'MY_PENDING',
        APPROVERD: 'MY_APPROVED',
        REJECTED: 'MY_REJECTED',
        CANCELLED: 'MY_CANCELLED',
        all: 'NOTIFIED',
        notread: 'NOTIFIED_UNREAD'
      },
      h5_url: app_config.h5_url,
      post_web_data: {
        platform: process.env.VUE_APP_H5_PLATFORM,
        short_name: 'Hk',
        theme: 'light',
        token: null,
        id: null,
        i18n: 'hk',
        teamId: null,
        leaveId: null,
        formId: null,
        actualWorkingClassTime: null,
        origin: process.env.VUE_APP_MAIN_REDIRECT_URL
      },
      data: [],
      tabs: {
        approval_forms: ['approval_forms', 'had_approved'],
        forms: ['All', 'APPROVERD', 'PENDING', 'REJECTED', 'CANCELLED'],
        copied_forms: ['all', 'notread']
      },
      isBatchOperation: false,
      selectedData: [],
      images: [],
      index: null,
      selectAll: false,
      curPageSelectAll: false,
      isSearchClick: false,
      searchAdvancedParams: null,
      transferForms: [],
      readBtnLoading: false
    };
  },
  computed: {
    columns() {
      const columns = [
        {
          title: this.$t('approval.applicant'),
          render: (_h, { row }) => {
            return (
              <Row align="middle" type="flex">
                <Avatar
                  size={28}
                  src={row.employee.avatar}
                  style={
                    row.employee.avatar ? '' : 'background: rgb(186, 217, 255)'
                  }
                  circle
                >
                  {this.$substrName(row.employee.displayName)}
                </Avatar>
                <span class="name">{row.employee.displayName}</span>
              </Row>
            );
          }
        },
        {
          title: this.$t('approval.approvalName'),
          align: 'center',
          render: (_h, { row }) => {
            return (
              <div>
                <p>{row.title}</p>
                {row.cancelProcessFlag && (
                  <p>{this.$t('approval.cancelProcessFlag')}</p>
                )}
              </div>
            );
          }
        },
        {
          title: this.$t('approval.approvalCode'),
          align: 'center',
          render: (_h, { row }) => {
            return (
              <div>
                <p>{row.id}</p>
                {row.cancelForm && (
                  <p>{`(${this.$t('approval.originalCode')}：${
                    row.cancelForm.id
                  })`}</p>
                )}
                {row.newForm && (
                  <p>{`(${this.$t('approval.newCode')}：${row.newForm.id})`}</p>
                )}
              </div>
            );
          }
        },
        {
          title: this.$t('approval.applicationTime'),
          align: 'center',
          render: (_h, { row }) => {
            return (
              <p>
                {this.$moment(`${row.createdAt}Z`).format('YYYY-MM-DD HH:mm')}
              </p>
            );
          }
        },
        {
          title: this.$t('approval.summary'),
          align: 'left',
          render: (_h, { row }) => {
            return row.extension &&
              row.extension.digest &&
              row.extension.digest.length ? (
              row.extension.digest.map((v) => {
                return (
                  <p>
                    {v.name}：
                    {v.type === 'AMOUNT_INPUT' ? this.toThousands(v) : v.value}
                  </p>
                );
              })
            ) : (
              <p>-</p>
            );
          }
        }
      ];
      if (this.tab === 'approval_forms') {
        columns.push({
          title: this.$t('approval.operate'),
          align: 'center',
          key: 'operate',
          width: this.$i18n.locale === 'en' ? 430 : 300,
          render: (_h, { row }) => {
            const { currentFormFlow } = row;
            const { type } = currentFormFlow;
            return type === 'HANDLE' ? (
              <Button
                type="primary"
                disabled={this.isBatchOperation}
                onClick={this.onChangeStatus.bind(this, 'handle', row)}
              >
                {this.$t('btn.handle')}
              </Button>
            ) : (
              <Row type="flex" gutter={8}>
                {!_.includes(
                  ['CANCELLED', 'REJECTED', 'CANCELING'],
                  row.status
                ) && (
                  <Col>
                    <Button
                      class="reject-btn"
                      color="#B0B6BF"
                      disabled={this.isBatchOperation}
                      onClick={this.onChangeStatus.bind(
                        this,
                        'carbonCopy',
                        row
                      )}
                    >
                      {this.$t('btn.cc')}
                    </Button>
                  </Col>
                )}
                <Col>
                  <Button
                    class="reject-btn"
                    type="error"
                    ghost
                    disabled={this.isBatchOperation}
                    onClick={this.onChangeStatus.bind(this, 'reject', row)}
                  >
                    {this.$t('btn.text2')}
                  </Button>
                </Col>
                <Col>
                  <Button
                    ghost
                    disabled={this.isBatchOperation}
                    onClick={this.onChangeStatus.bind(this, 'forward', row)}
                    type="primary"
                  >
                    {this.$t('btn.text1')}
                  </Button>
                </Col>
                <Col>
                  <Button
                    disabled={this.isBatchOperation}
                    onClick={this.onChangeStatus.bind(this, 'approve', row)}
                    type="primary"
                  >
                    {this.$t('btn.text3')}
                  </Button>
                </Col>
              </Row>
            );
          }
        });
      } else {
        columns.push({
          title: this.$t('approval.status'),
          align: 'center',
          render: (_h, { row }) => {
            return (
              <span class={`status ${row.status}`}>
                {this.$t(`approval.${row.status}`)}
              </span>
            );
          }
        });
      }
      if (this.isBatchOperation) {
        columns.unshift({
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left'
        });
      } else if (columns[0].type === 'selection') {
        columns.shift();
      }
      return columns;
    },
    // 拆分已选择审批文案
    selectedTexts() {
      return _.split(this.$t('approval.selectedApproval'), '$1');
    }
  },
  mounted() {
    this.initCategories();
    window.addEventListener(
      'message',
      (e) => {
        //圖片預覽
        if (_.isObject(e.data) && e.data.type === 'previewImage') {
          this.images = e.data.urls;
          this.index = e.data.current;
        }
        if (_.isObject(e.data) && e.data.type === 'report') {
          this.$router.push({
            path: `/approval/${e.data.id}/form?formId=${e.data.formId}&type=approver_form`
          });
        }
        if (_.isObject(e.data) && e.data.type === 'home') {
          this.$router.push({
            path: `/`
          });
        }
      },
      false
    );
    const { type, id, userId, from } = this.$route.query;
    this.active = this.tabs[type][0];
    if (this.active === 'all') {
      this.filters.readFlag = true;
    }

    if (from === 'transit' && userId !== this.$store.state.self.user.passport) {
      // 非同一账号
      this.$router.replace('/approverError?type=notFound');
    } else if (id) {
      this.initShow(id);
    }
    this.tab = type;
    this.getData();
  },
  methods: {
    //金額顯示千分位
    toThousands(extension) {
      const newProps = JSON.parse(extension.props);
      return !newProps.thousandth
        ? extension.value
        : (extension.value || 0).toString().replace(/\d+/, (n) => {
            // 先提取整数部分
            return n.replace(/(\d)(?=(\d{3})+$)/g, ($1) => {
              return $1 + ',';
            });
          });
    },
    // 关闭批量转交
    onBatchTransferCancel() {
      this.isBatchOperation = false;
      this.transferForms = [];
      this.selectedData = [];
      this.$refs.oaTable.selectAll(false);
    },
    // 查看已选转交数据变更
    onCheckTransferSelectedChange(values) {
      this.onTableSelectAll(values);
      this.setTableDataChecked();
    },
    // 选择当前行
    onTableSelect(_selection, row) {
      this.selectedData.push({
        checked: true,
        employee: {
          avatar: row.employee.avatar,
          displayName: row.employee.displayName
        },
        title: row.title,
        id: row.id,
        createdAt: row.createdAt,
        flows: row.flows
      });
      const { currentFormFlow } = row;
      if (!currentFormFlow) return;
      const formFlowId = currentFormFlow.id;
      this.transferForms.push({
        formId: row.id,
        formFlowId
      });
      // 当全选中时
      if (this.selectedData.length === this.totalElements) {
        this.curPageSelectAll = true;
      } else if (this.curPageSelectAll) {
        this.curPageSelectAll = false;
      }
    },
    // 取消选择当前行
    onTableSelectCancel(selection, row) {
      if (this.selectAll) {
        // 全选时
        this.selectAll = false;
        this.selectedData = [];
        this.transferForms = [];
        _.forEach(selection, (v) => {
          this.onTableSelect(selection, v);
        });
      } else {
        // 非全选时
        _.remove(this.selectedData, (v) => v.id === row.id);
        this.selectedData = [...this.selectedData];
        _.remove(this.transferForms, (v) => v.formId === row.id);
        this.transferForms = [...this.transferForms];
      }
      // 当非全选中时
      if (this.curPageSelectAll) {
        this.curPageSelectAll = false;
      }
    },
    // 全选当前页
    onTableSelectAll(selection) {
      const data = _.map(selection, (v) => {
        return this.initItemData(v);
      });
      this.selectedData = _.uniqWith(
        [...this.selectedData, ...data],
        _.isEqual
      );
      if (!this.selectAll) {
        this.transferForms = _.map(selection, (v) => {
          const { currentFormFlow } = v;
          const formFlowId = currentFormFlow ? currentFormFlow.id : null;
          return {
            formId: v.id,
            formFlowId
          };
        });
      }
      // 当全选中时
      if (this.selectedData.length === this.totalElements) {
        this.curPageSelectAll = true;
      } else if (this.curPageSelectAll) {
        this.curPageSelectAll = false;
      }
    },
    // 取消全选当前页
    onTableSelectAllCancel() {
      if (this.selectAll) {
        // 全选时
        this.selectAll = false;
        this.selectedData = [];
        this.transferForms = [];
      } else {
        // 非全选时
        _.forEach(this.data, (v) => {
          _.remove(this.selectedData, (r) => r.id === v.id);
          _.remove(this.transferForms, (r) => r.formId === v.id);
        });
        this.selectedData = [...this.selectedData];
        this.transferForms = [...this.transferForms];
      }
      // 当非全选中时
      if (this.curPageSelectAll) {
        this.curPageSelectAll = false;
      }
    },
    // 全选
    onSelectAll() {
      this.selectAll = true;
      this.$refs.oaTable.selectAll(true);
    },
    // 取消全选
    onSelectAllCancel() {
      this.transferForms = [];
      this.selectedData = [];
      this.selectAll = false;
      this.$refs.oaTable.selectAll(false);
    },
    initItemData(v) {
      return {
        checked: true,
        employee: {
          avatar: v.employee.avatar,
          displayName: v.employee.displayName
        },
        title: v.title,
        id: v.id,
        createdAt: v.createdAt,
        flows: v.flows
      };
    },
    // 设置表格数据选中状态
    setTableDataChecked(type) {
      // 全选时搜索
      if (type === 'search' && this.selectAll) {
        if (this.data.length) {
          this.selectedData = _.map(this.data, (v) => {
            return this.initItemData(v);
          });
        } else if (this.filter.page === 0) {
          // 没数据时清空选择
          this.onSelectAllCancel();
        }
      } else if (this.selectAll) {
        setTimeout(() => {
          this.$refs.oaTable.selectAll(true);
        }, 300);
      } else {
        const data = this.data;
        _.forEach(data, (v) => {
          v._checked = _.some(this.selectedData, (s) => s.id === v.id);
        });
        this.data = [...data];
      }
    },
    // 查看已选
    onViewSelected() {
      this.$refs.checkTransferSelectedDrawerRef.show(this.selectedData);
    },
    // 批量操作
    onBatchOperation() {
      this.isBatchOperation = true;
    },
    onBatchConfirm(name) {
      if (name === 'approve') {
        // 同意
        this.$refs.approvalModalRef.show(
          'approve',
          true,
          _.map(this.selectedData, (m) => m.id)
        );
      } else if (name === 'reject') {
        // 拒绝
        this.$refs.approvalModalRef.show(
          'reject',
          true,
          _.map(this.selectedData, (m) => m.id)
        );
      } else if (name === 'transfer') {
        // 转交
        this.$refs.batchTransferModalRef.show();
      }
    },
    // 审批完成
    onApprovalOk() {
      this.onBatchTransferCancel();
      this.getData(this.searchAdvancedParams);
    },
    // 批量转交完成
    onBatchTransferOk() {
      this.onBatchTransferCancel();
      this.getData(this.searchAdvancedParams);
    },
    onOpenSearchAdvanced() {
      const item = _.find(
        this.categories,
        (v) => v.id === this.filters.approvalId
      );
      let type = this.tab;
      if (this.$route.query.type === 'forms') {
        type = 'me';
      }
      this.$refs.approvalSearchAdvanced.open({ id: item.id, type });
    },
    onSearchAdvanced(arr) {
      const params = arr.length
        ? {
            digest: arr
          }
        : null;
      this.searchAdvancedParams = params;
      this.getData(params);
    },
    onSearch() {
      this.isSearchClick = true;
      this.filters.page = 0;
      this.getData();
    },
    // 重置搜搜
    onReset() {
      this.filters.approvalId = null;
      this.filters.createdAtStart = null;
      this.filters.createdAtEnd = null;
      this.filters.starter = null;
      this.filters.idIndex = null;
      this.isAdvancedSearch = false;
      this.isSearchClick = false;
      this.getData();
    },
    // 发起时间选择
    onDateChange(date) {
      this.filters.createdAtStart = date[0];
      this.filters.createdAtEnd = date[1];
    },
    onTabChange(e) {
      this.filters = _.cloneDeep(this.initFilter);
      this.tab = this.$route.query.type;
      this.active = e;
      switch (this.$route.query.type) {
        case 'forms':
          this.filters.status = e === 'All' ? null : e;
          break;
        case 'approval_forms':
          this.tab = e;
          break;
        case 'copied_forms':
          this.filters.readFlag = e === 'notread' ? false : true;
          break;
      }
      this.getData();
    },
    async initCategories() {
      if (this.categories.length === 0) {
        try {
          const res = await this.$http(
            'get',
            'mobile/approval/categories',
            { visibleAll: true },
            true
          );
          _.forEach(res.data.content, (v) => {
            this.categories.push(...v.approvals);
          });
        } catch (e) {
          console.log(e);
        }
      }
    },
    // 清空审批类型下拉框
    onApprovalClear() {
      this.isAdvancedSearch = false;
    },
    // 选择审批类型
    onApprovalChange(id) {
      // 根据是否有自定义摘要设置高级筛选按钮显示隐藏
      const item = _.find(this.categories, (f) => f.id === id);
      this.isAdvancedSearch =
        item && item.extension && item.extension.digest.length > 0;
    },
    objToUrl(obj) {
      const tempArray = [];
      for (const key in obj) {
        if (key && obj[key] !== null && obj[key] !== '') {
          tempArray.push(`${key}=${obj[key]}`);
        }
      }
      return `?${tempArray.join('&')}`;
    },
    async getData(params) {
      try {
        this.loading = true;
        const newFilters = _.cloneDeep(this.filters);
        // 选择“全部” tab，删除readFlag字段
        if ((this.active + '').toLocaleLowerCase() === 'all') {
          delete newFilters.readFlag;
        }
        if (params) {
          delete newFilters.page;
          delete newFilters.size;
        }
        _.forEach(newFilters, (v, k) => {
          if (_.isNil(newFilters[k])) {
            _.unset(newFilters, k);
          }
        });
        const urlParams = this.objToUrl(newFilters);
        let url = 'mobile/forms';
        if (this.$route.query.type === 'forms') {
          url += `/me${urlParams}`;
        } else {
          url += `/${this.tab}${urlParams}`;
        }
        const res = await this.$http('post', url, params, true);
        this.data = res.data.content;
        if (this.$route.query.type === 'approval_forms') {
          _.forEach(this.data, (v) => {
            if (v.currentFormFlow && v.currentFormFlow.type === 'HANDLE') {
              this.$set(v, '_disabled', true);
            }
          });
        }
        this.totalElements = res.data.totalElements;
        this.totalPages = res.data.totalPages;
        this.setTableDataChecked(params ? 'search' : null);
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
    changPage(val, type) {
      if (type === 'size') {
        this.filters['page'] = 0;
      }
      this.filters[type] = type === 'page' ? val - 1 : val;
      this.getData();
    },
    async initShow(id) {
      try {
        const { data } = await this.$http(
          'get',
          `/mobile/forms/${id}`,
          {},
          true
        );
        this.sendMsg(data);
      } catch (e) {
        if (e.data.code === 500) {
          this.$router.replace('/approverError?type=remove');
        }
      }
    },
    sendMsg(row) {
      this.drawerValue = true;
      this.$nextTick(() => {
        let iframe = document.getElementById('iframe');
        this.h5_url = `${app_config.h5_url}/#/pages/show?type=pc&id=${
          row.id
        }&from=${this.filter_from[this.$route.query.type]}`;
        iframe.onload = () => {
          this.post_web_data.token = {
            token_type: 'bearer',
            access_token: AuthManage.token,
            id_token: AuthManage.idToken,
            expires_in: AuthManage.expiresAt,
            refresh_token: AuthManage.refreshToken
          };
          this.post_web_data.teamId = localStorage.getItem('teamId');
          this.post_web_data.id = row.id;
          this.post_web_data.i18n = this.$i18n.locale;
          iframe.contentWindow.postMessage(
            JSON.stringify(this.post_web_data),
            app_config.h5_url
          );
        };
      });
    },
    onChangeStatus(status, e) {
      event.stopPropagation();
      switch (status) {
        case 'handle':
          this.sendMsg(e);
          break;
        case 'forward':
          // 转交
          this.$refs.transferModalRef.show(e);
          break;
        case 'carbonCopy':
          // 抄送
          this.$refs.carbonCopyModalRef.openModal(e);
          break;
        default:
          // 审批
          this.$refs.approvalModalRef.show(status, false, e);
          break;
      }
    },
    // 全部标为已读
    async onAllMarkedAsRead() {
      try {
        this.readBtnLoading = true;
        await this.$http('put', 'mobile/forms/all_read', {}, true);
        this.readBtnLoading = false;
        this.$Message.success(this.$t('approval.readSuccess'));
        this.getData();
      } catch (e) {
        this.readBtnLoading = false;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.approval {
  height: 100%;
  display: flex;
  flex-direction: column;

  .my-25 {
    margin-top: 25px;
    margin-bottom: 25px;
  }

  .mb-15 {
    margin-bottom: 10px;
  }

  .ivu-tabs {
    height: auto;
  }
}

.row-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.table-box {
  position: relative;
  flex: 1;

  /deep/ .ivu-table-tip td {
    padding: 40px 0;
    cursor: default !important;
  }
}

.filter-box {
  margin-bottom: 10px;

  .ivu-select,
  .ivu-input-number,
  .ivu-input-wrapper,
  .ivu-date-picker {
    width: 180px;
  }
}

/deep/ .ivu-table-wrapper {
  .ivu-table-row {
    height: auto;
    padding: 10px 0;
  }

  .ivu-table td {
    height: auto;
    cursor: pointer;

    .ivu-table-cell {
      padding: 18px;
      white-space: normal;
    }
  }

  .APPROVERD {
    background: rgba(#00cb80, 0.08);
    color: #00cb80;
  }

  .REJECTED {
    background: rgba(#f54b45, 0.08);
    color: #f54b45;
  }

  .PENDING {
    background: rgba(#f7a33e, 0.08);
    color: #f7a33e;
  }

  .CANCELLED {
    background: rgba(#515a6e, 0.08);
    color: #515a6e;
  }

  .name {
    font-size: 16px;
    font-weight: 400;
    color: #1f2329;
    line-height: 22px;
    margin-left: 8px;
  }
}

.operator-box {
  height: 120px;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding-top: 48px;
  box-sizing: border-box;
  z-index: 1000;

  .operator {
    height: 72px;
    background-color: #fff;
    padding: 0 20px;
    box-shadow: 0px -10px 10px -5px rgba(0, 0, 0, 0.04),
      0px -20px 25px -5px rgba(0, 0, 0, 0.1);
    font-size: 14px;
  }
}

/deep/.ivu-tabs {
  &-tab {
    font-size: 14px;
  }
  &-tab-active {
    color: #217d8d !important;
    font-weight: 500 !important;
  }
  &-ink-bar {
    height: 4px;
  }
}

#iframe {
  border: none;
}

.read-btn {
  color: #39aba7;
  margin-top: 11px;
  padding: 0;

  &:focus {
    box-shadow: none;
  }

  &[disabled] {
    color: #c5c8ce;
  }
}
</style>
